import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TestimonialListLayer from "../components/TestimonialListLayer";

const TestimonialListPage = () => {
    return (
        <MasterLayout>
            <TestimonialListLayer />
        </MasterLayout>
    );
};

export default TestimonialListPage;
